export default function openPopoutPlayerWindow(url, width, height) {
  const { screenLeft, screenX, innerWidth } = window;

  let attributes = `width=${width},height=${height}`;
  attributes += `,top=0,left=${(screenLeft || screenX) + (innerWidth - width)}`;

  return window.open(url, '_blank', attributes);
}
